/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'custompage': {
    width: 16,
    height: 22,
    viewBox: '0 0 16 22',
    data: '<path pid="0" d="M11.71 1.01H1.496a.24.24 0 0 0-.24.241v19.08c0 .133.107.24.24.24h13.252a.24.24 0 0 0 .24-.24V4.29h-3.28V1.01zm1 .708V3.29h1.572L12.71 1.718zM4.195 8.284l.027-.031 3.705-1.56.008.018c.153-.076.22-.076.373 0l.008-.018 3.735 1.573.041.05c.144.034.176.122.223.33a27.682 27.682 0 0 1 .015.07v4.153c-.041.257-.041.257-.276.448l-.03.014-3.743 1.571c-.06.002-.113.003-.16.002-.046 0-.098 0-.159-.002l-.036-.013-3.736-1.572c-.235-.191-.235-.191-.277-.448V8.716a52.06 52.06 0 0 1 .026-.089c.067-.224.106-.309.256-.343zM12.416.01l3.573 3.573V20.33a1.24 1.24 0 0 1-1.24 1.24H1.497a1.24 1.24 0 0 1-1.24-1.24V1.25c0-.685.554-1.24 1.24-1.24h10.92zM7.624 10.606l-2.71-1.14v3.071l2.71 1.14v-3.071zm3.709-1.139l-2.71 1.138v3.071l2.71-1.139v-3.07zm-.79-.752l-2.42-1.019-2.42 1.018 2.42 1.017 2.42-1.016z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/custompage.js